import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { Button, Loader, Tabs } from '@tucar/pit-stop';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TopNav2 from '../../../components/ui/TopNav/newTopNav';
import { useSalesforceContext } from '../../../contexts/SalesforceContext';
import GET_CHATS from '../../../graphql/querys/salesforce/getChats';
import { getAuthStore } from '../../../graphql/store';
import getUniqueKey from '../../../helpers/customKey';
import { liquidationCardStyle } from '../../app/dashBoard/newDashboard/sections/PaymentDebtCard';

const SalesforceCasesScreen = () => {
  const {
    data: { uid },
  } = useReactiveVar(getAuthStore);
  const { openSalesforceChat } = useSalesforceContext();
  const handleChatButtonClick = () => openSalesforceChat();
  const [tab, setTab] = useState('Casos abiertos');
  const [getChats, { data, loading }] = useLazyQuery(GET_CHATS.query, {
    skip: uid === '',
    ...GET_CHATS.policies,
  });
  const [chats, setChats] = useState([]);

  useEffect(() => {
    getChats({
      variables: {
        driverId: uid || '',
        caseStatus: tab === 'Casos abiertos' ? 'active' : 'closed',
        limit: 30,
        offset: 0,
      },
    });
  }, [tab]);

  useEffect(() => {
    if (data?.getChats?.chats && !loading) {
      setChats(data.getChats.chats);
    }
  }, [data, loading]);

  return (
    <Box sx={{ position: 'relative', paddingBottom: '80px' }}>
      <TopNav2 title="Mensajería" prevPage="/app/v2/support/" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          padding: '0px 30px',
        }}
      >
        <Button size="large" onClick={handleChatButtonClick}>
          Iniciar un nuevo chat
        </Button>
        <Tabs
          size="large"
          currentTab={tab}
          onChange={(event) => setTab(event.target.value)}
          tabs={[{ value: 'Casos abiertos' }, { value: 'Casos cerrados' }]}
          style={{ paddingInline: 0 }}
        />

        <Box sx={{ ...liquidationCardStyle, width: '100%', margin: '0px', minWidth: 'unset' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', zIndex: 1 }}>
            <Typography
              color="#5B5D71"
              style={{ fontSize: '14px', fontWeight: 500, lineHeight: '1.2', textAlign: 'center' }}
            >
              Haz click en un caso para copiar su número y abrir el chat asociado.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: loading ? 'flex' : 'none', justifyContent: 'center', padding: '20px' }}>
          <Loader />
        </Box>

        <Box
          sx={{
            display: !loading ? 'flex' : 'none',
            flexDirection: 'column',
            gap: '10px',
            width: '100%',
          }}
        >
          {chats.length > 0 ? (
            chats.map((chat) => {
              return (
                <CopyToClipboard key={getUniqueKey()} text={chat.caseNumber}>
                  <Box
                    onClick={() => openSalesforceChat(chat.conversationIdentifier)}
                    sx={{
                      cursor: 'pointer',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      width: '100%',
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box
                      sx={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '80%' }}
                    >
                      <Typography color="#5B5D71">
                        {chat.caseNumber
                          ? `Nº Caso: ${chat.caseNumber}`
                          : 'Número de caso no disponible'}
                      </Typography>
                      <Typography
                        sx={{
                          color: '#5B5D71',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          lineHeight: '1.2',
                        }}
                      >
                        {chat.caseSubject || 'Sin asunto'}
                      </Typography>
                    </Box>
                  </Box>
                </CopyToClipboard>
              );
            })
          ) : (
            <Typography
              color="#5B5D71"
              sx={{ display: 'flex', textAlign: 'center', padding: '20px' }}
            >
              No tienes casos {tab === 'Casos abiertos' ? 'abiertos' : 'cerrados'} disponibles.
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SalesforceCasesScreen;
